export const sortByTimeIfExists = ({ time: aTime }, { time: bTime }) => {
  if (!aTime && !bTime) {
    return 0 // Both times are missing, consider them equal
  }
  if (!aTime) {
    return 1 // Place item with missing time after those with time
  }
  if (!bTime) {
    return -1 // Place item with missing time after those with time
  }
  return aTime - bTime // Sort by time if both exist
}

export const getSortByStringPropertyIfExists = propertyName => (a, b) => {
  const propA = a[propertyName]
  const propB = b[propertyName]
  const propAIsString = typeof propA === 'string'
  const propBIsString = typeof propB === 'string'

  // Check if the properties exist and are strings before comparing
  if (propAIsString && propBIsString) {
    return propA.localeCompare(propB)
  } else if (propAIsString) {
    // Assume non-existent or non-string properties are 'less' than string properties
    return -1
  } else if (propBIsString) {
    // Assume non-existent or non-string properties are 'less' than string properties
    return 1
  }
  // If neither property is a string, consider them equal
  return 0
}

export const sortByNameIfExists = getSortByStringPropertyIfExists('name')
